/** Direct-session progress lines (tests/fixtures/activity-labels/progress.json). English equals the fixture exactly. */
export default {
  "progress.editing": "Editing {file}",
  "progress.reading": "Reading {file}",
  "progress.running": "Running {command}",
  "progress.searching_code": "Searching the code",
  "progress.searching_web": "Searching the web",
  "progress.working_with_agent": "Working with an agent",
  "progress.updating_plan": "Updating the plan",
  "progress.editing_files": "Editing files",
  "progress.using_tool": "Using {tool}",
} as const;
